import * as actions from './actions'
import mutations from './mutations'
import modules from './modules'

let state = {
    items: [],
    total: 0,

    currentProjectId: null
};

export default {
    mutations, actions, state, modules
}